import { render, staticRenderFns } from "./OrdersNumber.vue?vue&type=template&id=645336e6&scoped=true&"
import script from "./OrdersNumber.vue?vue&type=script&lang=js&"
export * from "./OrdersNumber.vue?vue&type=script&lang=js&"
import style0 from "./OrdersNumber.vue?vue&type=style&index=0&id=645336e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645336e6",
  null
  
)

export default component.exports